import axios from 'axios';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';
import { Toast } from 'primereact/toast';
import { FilterMatchMode } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Skeleton } from 'primereact/skeleton';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { Badge } from 'primereact/badge';
import StoreSelect from '../../Components/Store';
import { useNavigate } from 'react-router-dom';

const UsersList = () => {
    const { apiUrl, apiHeadersJson, store_id } = useContext(ConfigContext);
    const [dataTableLoading, setDataTableLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const [keyword, setKeyword] = useState('');
    const navigate = useNavigate();

    const headers = apiHeadersJson;
    const toast = useRef(null);

    const getList = async () => {
        setDataTableLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/User/GetUserList`, { params: { keyword, store_id: store_id }, headers });
            const { success, data, message } = response.data;

            if (success) {
                setRows(data);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setDataTableLoading(false);
        }
    };


    const confirmDelete = (id) => {
        confirmDialog({
            message: 'Are you sure you want to delete this user?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => deleteUser(id),
            reject: () => {
                toast.current.show({ severity: 'info', summary: 'Cancelled', detail: 'Delete operation cancelled', life: 3000 });
            }
        });
    };

    const confirmCheck = (data, action) => {
        console.log(action);
        console.log(data);

        confirmDialog({
            message: `Are you sure you want to ${action} this user?`,
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => ActionUser(data.user_id, action),
            reject: () => {
                toast.current.show({ severity: 'message', summary: 'Action', detail: 'Action operation cancelled', life: 3000 });
            }
        });
    };

    const deleteUser = async (id) => {
        try {
            const response = await axios.delete(`${apiUrl}/User/DeleteUser`, { params: { user_id: id }, headers });
            const { success, message } = response.data;

            if (success) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                getList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };


    const ActionUser = async (id, action) => {

        try {
            const response = await axios.post(`${apiUrl}/User/ActionUser`, { user_id: id, user_status: action }, { headers });
            const { success, message } = response.data;

            if (success) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                getList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const addUser = () => {
        navigate(`/Users`);
    }

    const editUser = async (id) => {
        navigate(`/Users/${id}`);
    };

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            if (keyword) {
                getList();
            }
        }, 500);
        return () => clearTimeout(delayDebounce);
    }, [keyword]);

    useEffect(() => {
        getList();
    }, [store_id]);


    const ActionBody = (data) => {
        return (
            <>
                <InputSwitch checked={data.user_status === 'active'} size={'small'} onChange={(e) => {
                    const newStatus = e.value ? 'active' : 'inactive';
                    confirmCheck(data, newStatus);
                }} />
                <Button icon="pi pi-pencil" className='ms-3' outlined size={'small'} onClick={() => editUser(data.user_id)} />
                <Button outlined className='ms-3' icon="pi pi-trash" severity="danger" size={'small'} onClick={() => confirmDelete(data.user_id)} />
            </>
        );
    };

    const ActuvesRole = (data) => {
        const UsersRole = [
            { user_role_label: "Admin", user_role_value: "admin" },
            { user_role_label: "Store Admin", user_role_value: "store_admin" },
            { user_role_label: "M.User", user_role_value: "m_user" },
            { user_role_label: "S.User", user_role_value: "s_user" },
            { user_role_label: "QR Device", user_role_value: "qr" },
        ];
        const userRole = UsersRole.find((role) => role.user_role_value === data.user_role);

        return (
            <>
                {userRole.user_role_label}
            </>
        );
    };

    const StatusBadge = (data) => {
        return (
            <>
                {data.user_status}
            </>
        );
    };

    return (
        <>
            <div className="container-fluid">
                <Toast ref={toast} />
                <div className="d-flex justify-content-between align-items-center my-4">
                    <div className="main-heading">
                        <h6>Users</h6>
                    </div>
                    <div className="main-heading-right">
                        <h6>Management/Users</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="rounded-top px-3 py-2 bg-dark d-flex flex-wrap justify-content-between align-items-center">
                                <h4 className="text-white">Users List</h4>
                                <IconField iconPosition="left">
                                    <InputIcon className="pi pi-search"> </InputIcon>
                                    <InputText
                                        className='w-100'
                                        placeholder="Search By User Name..."
                                        onChange={(e) => setKeyword(e.target.value)}
                                    />
                                </IconField>
                                <Button icon="pi pi-plus-circle" severity="secondary" rounded onClick={addUser} />
                            </div>
                            {dataTableLoading ? (
                                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(() => (
                                    <Skeleton shape="rectangle" width="100%" height="40px" className="mb-1" />
                                ))
                            ) : (
                                <DataTable value={rows} paginator rows={10} rowsPerPageOptions={[10, 20, 30]}>
                                    <Column field="user_name" header="User" />
                                    <Column field="store_name" header="Store" />
                                    <Column field="login_id" header="Id" />
                                    <Column field="login_password" header="Password" />
                                    <Column field="user_salary_type" header="Type" />
                                    <Column field="user_salary_amount" header="Amount" />
                                    <Column field={ActuvesRole} header="Role" />
                                    <Column field={StatusBadge} header="Status" />
                                    <Column body={ActionBody} header="Action" />
                                </DataTable>
                            )}
                        </div>
                    </div>
                </div >
            </div >
        </>
    );
};

export default UsersList;


// const routes = [
//     {
//         path: "/",
//         label: "Dashboard",
//         icon: "pi pi-home",
//         routename: "Dashboard",
//     },
//     {
//         label: "Masters",
//         icon: "pi pi-database",
//         routename: "Masters",
//         children: [
//             { path: "/Store", label: "Store", routename: "Store" },
//             { path: "/Category", label: "Category", routename: "Category" },
//             { path: "/Product", label: "Products", routename: "Products" },
//             { path: "/Expenses", label: "Expenses", routename: "Expenses" },
//             { path: "/Customers", label: "Customers", routename: "Customers" },
//             { path: "/Users", label: "Users", routename: "Users" },
//             { path: "/OfferTime/1", label: "Offer Time", routename: "OfferTime" },
//             { path: "/Supplier", label: "Suppliers", routename: "Suppliers" },
//         ],
//     },
//     {
//         label: "Entries",
//         icon: "pi pi-pencil",
//         routename: "Entries",
//         children: [
//             { path: "/Purchase", label: "Purchase", routename: "Purchase" },
//             { path: "/Sales", label: "Sales", routename: "Sales" },
//             { path: "/EmployeeSales", label: "Employee Sales", routename: "EmployeeSales" },
//             { path: "/ExpensesEntry", label: "Expenses Entry", routename: "ExpensesEntry" },
//             { path: "/OrdersEntry", label: "Orders", routename: "Orders Entry" },
//         ],
//     },
//     {
//         label: "Return Entries",
//         icon: "pi pi-undo",
//         routename: "Return Entries",
//         children: [
//             { path: "/SalesReturn", label: "Sales Return", routename: "SalesReturn" },
//             { path: "/PurchaseReturn", label: "Purchase Return", routename: "PurchaseReturn" },
//         ],
//     },
//     {
//         label: "Reports",
//         icon: "pi pi-folder-open",
//         routename: "Reports",
//         children: [
//             { path: "/PurchaseReports/30/DESC", label: "Purchase Report", routename: "PurchaseReport" },
//             { path: "/PurchaseReturnReports/30/DESC", label: "Purchase Return Report", routename: "PurchaseReturnReport" },
//             { path: "/SaleReports/30/DESC", label: "Sales Report", routename: "SalesReport" },
//             { path: "/EmployeeSalesReport/30/DESC", label: "Employee Sales Report", routename: "EmployeeSalesReport" },
//             { path: "/SaleReturnReports/30/DESC", label: "Sales Return Report", routename: "SalesReturnReport" },
//             { path: "/OrderReport/30/DESC", label: "Orders Report", routename: "OrdersReport" },
//             { path: "/ExpensesReports/30/DESC", label: "Expenses Report", routename: "ExpensesReport" },
//             { path: "/StockReport/300/DESC", label: "Stock Report", routename: "StockReport" },
//         ],
//     },
//     {
//         label: "View",
//         icon: "pi pi-eye",
//         routename: "View",
//         children: [
//             { path: "/ViewSale", label: "View Sale", routename: "ViewSale" },
//             { path: "/ViewOrder", label: "View Order", routename: "ViewOrder" },
//             { path: "/ViewPurchase", label: "View Purchase", routename: "ViewPurchase" },
//             { path: "/ViewPurchaseReturn", label: "View Purchase Return", routename: "ViewPurchaseReturn" },
//             { path: "/ViewSalesRetuirn", label: "View Sales Return", routename: "ViewSalesReturn" },
//             { path: "/ViewEmployeeSales", label: "View Employee Sales", routename: "ViewEmployeeSales" },
//         ],
//     },
//     {
//         label: "Print",
//         icon: "pi pi-print",
//         routename: "Print",
//         children: [
//             { path: "/PrintSale", label: "Print Sale", routename: "PrintSale" },
//             { path: "/PrintPurchase", label: "Print Purchase", routename: "PrintPurchase" },
//             { path: "/PrintOrder", label: "Print Order", routename: "PrintOrder" },
//             { path: "/TodaysPrint", label: "Today's Print", routename: "TodaysPrint" },
//             { path: "/PrintPurchaseReturn", label: "Print Purchase Return", routename: "PrintPurchaseReturn" },
//             { path: "/SaleReturnInvoice", label: "Sale Return Invoice", routename: "SaleReturnInvoice" },
//         ],
//     },
//     {
//         path: "/Settings",
//         label: "Settings",
//         icon: "pi pi-cog",
//         routename: "Settings",
//     },
// ];

// const routes = [
//     { label: "Dashboard", routename: "Dashboard" },
//     { label: "Masters", routename: "Masters", headline: true },
//     { label: "Store", routename: "Store" },
//     { label: "Category", routename: "Category" },
//     { label: "Products", routename: "Products" },
//     { label: "Expenses", routename: "Expenses" },
//     { label: "Customers", routename: "Customers" },
//     { label: "Users", routename: "Users" },
//     { label: "Offer Time", routename: "OfferTime" },
//     { label: "Suppliers", routename: "Suppliers" },
//     { label: "Entries", routename: "Entries", headline: true },
//     { label: "Purchase", routename: "Purchase" },
//     { label: "Sales", routename: "Sales" },
//     { label: "Employee Sales", routename: "EmployeeSales" },
//     { label: "Expenses Entry", routename: "ExpensesEntry" },
//     { label: "Orders", routename: "Orders Entry" },
//     { label: "Return Entries", routename: "Return Entries", headline: true },
//     { label: "Sales Return", routename: "SalesReturn" },
//     { label: "Purchase Return", routename: "PurchaseReturn" },
//     { label: "Reports", routename: "Reports", headline: true },
//     { label: "Purchase Report", routename: "PurchaseReport" },
//     { label: "Purchase Return Report", routename: "PurchaseReturnReport" },
//     { label: "Sales Report", routename: "SalesReport" },
//     { label: "Employee Sales Report", routename: "EmployeeSalesReport" },
//     { label: "Sales Return Report", routename: "SalesReturnReport" },
//     { label: "Orders Report", routename: "OrdersReport" },
//     { label: "Expenses Report", routename: "ExpensesReport" },
//     { label: "Stock Report", routename: "StockReport" },
//     { label: "View", routename: "View", headline: true },
//     { label: "View Sale", routename: "ViewSale" },
//     { label: "View Order", routename: "ViewOrder" },
//     { label: "View Purchase", routename: "ViewPurchase" },
//     { label: "View Purchase Return", routename: "ViewPurchaseReturn" },
//     { label: "View Sales Return", routename: "ViewSalesReturn" },
//     { label: "View Employee Sales", routename: "ViewEmployeeSales" },
//     { label: "Print", routename: "Print", headline: true },
//     { label: "Print Sale", routename: "PrintSale" },
//     { label: "Print Purchase", routename: "PrintPurchase" },
//     { label: "Print Order", routename: "PrintOrder" },
//     { label: "Today's Print", routename: "TodaysPrint" },
//     { label: "Print Purchase Return", routename: "PrintPurchaseReturn" },
//     { label: "Sale Return Invoice", routename: "SaleReturnInvoice" },
//     { label: "Settings", routename: "Settings" }
// ];